import { render, staticRenderFns } from "./CallRecord.vue?vue&type=template&id=4197d1b8&scoped=true&"
import script from "./CallRecord.vue?vue&type=script&lang=js&"
export * from "./CallRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4197d1b8",
  null
  
)

export default component.exports